export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Menu-Gray-2ca5b48414c0e9701d08873ac91d67c4.svg";